import { addCompanyMemberApi } from '@api/companyApi';
import { Actions } from '@constants/actionTypes';
import type {
  AddCompanyMemberDTO,
  CreateMemberDTO,
} from '@conversed/shared/src/central/dto/company';
import { toastErrorTranslated, toastSuccessTranslated } from '@helpers/toast';
import { useMainDispatch } from '@hooks/useMainDispatch';
import { useCallback } from 'react';
import { isAlreadyMemberError } from '../users.helpers';

type TInviteMemberResult = 'invited' | 'already-member' | 'failed';

export const useInviteMember = () => {
  const dispatch = useMainDispatch();

  const inviteMember = useCallback(
    async (memberData: CreateMemberDTO): Promise<TInviteMemberResult> => {
      try {
        // * The same endpoint changes the roles of an existing member. Only an
        // * invite asks the backend to answer 409 for an existing member.
        const invitePayload: AddCompanyMemberDTO = {
          ...memberData,
          rejectExistingMember: true,
        };
        const { data: member } = await addCompanyMemberApi(invitePayload);
        dispatch({ type: Actions.ADD_COMPANY_MEMBER, payload: member });
        toastSuccessTranslated('users.invite.success');

        return 'invited';
      } catch (error) {
        // * The modal shows this case on the email field, not as a toast.
        if (isAlreadyMemberError(error)) {
          return 'already-member';
        }

        console.error(error);
        toastErrorTranslated(error);

        return 'failed';
      }
    },
    [dispatch],
  );

  return { inviteMember };
};
